// FLAGS: none
// The app-wide React Query cache: five-minute staleness, no refetch on focus, and no retry on 401/403
// so an expired session surfaces at once instead of being retried.
import { QueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { minutes } from "@src/utils/time";

const isAuthError = (error: unknown): boolean =>
  isAxiosError(error) &&
  (error.response?.status === 401 || error.response?.status === 403);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: minutes(5),
      retry: (failureCount, error) => !isAuthError(error) && failureCount < 2,
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
